import React from 'react';
import Notifier from 'common/helpers/Notifier';
import PropTypes from 'prop-types';
import './ClientProfileLink.scss';

const ClientProfileLink = ({
  children = 'Copy Profile Link',
  linkToCopy = null,
  successMessage = 'Link has been copied to clipboard.',
}) => {
  const handleCopy = () => {
    const textToCopy = linkToCopy || window.location.href;

    navigator.clipboard.writeText(textToCopy).then(() => {
      Notifier.dispatch('success', successMessage);
    }).catch(() => {
      Notifier.dispatch('error', 'Failed to copy to clipboard.');
    });
  };

  return (
    <div className="client-profile-div">
      <h3 className="client-profile-link">
        <a onClick={handleCopy} style={{ cursor: 'pointer' }}>
          {children}
        </a>
      </h3>
    </div>
  );
};

ClientProfileLink.propTypes = {
  children: PropTypes.string,
  linkToCopy: PropTypes.string,
  successMessage: PropTypes.string,
};

export default ClientProfileLink;
